import { useSearchParams } from "react-router-dom";
import { useState, useEffect } from "react";
import { tools } from "@/data/tools";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import ToolCard from "@/components/ToolCard";

export default function SearchResults() {
  const [searchParams] = useSearchParams();
  const query = searchParams.get("q") || "";
  const [searchResults, setSearchResults] = useState<typeof tools>([]);

  useEffect(() => {
    if (query) {
      const results = tools.filter(tool =>
        tool.name.toLowerCase().includes(query.toLowerCase()) ||
        tool.description.toLowerCase().includes(query.toLowerCase())
      );
      setSearchResults(results);
    } else {
      setSearchResults([]);
    }
  }, [query]);

  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-grow">
        <div className="container mx-auto px-4 py-8">
          <h1 className="text-2xl font-bold mb-6">
            Search Results for: <span className="text-[var(--primary)]">"{query}"</span>
          </h1>
          
          {searchResults.length === 0 ? (
            <div className="bg-white rounded-lg shadow-md p-8 text-center">
              <i className="fa-regular fa-face-frown text-4xl text-gray-400 mb-4"></i>
              <h3 className="text-xl font-semibold mb-2">No tools found</h3>
              <p className="text-gray-600">Try a different search term</p>
            </div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
              {searchResults.map(tool => (
                <ToolCard key={tool.id} tool={tool} />
              ))}
            </div>
          )}
        </div>
      </main>
      <Footer />
    </div>
  );
}